"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FilterCondition = _interopRequireDefault(require("../FilterCondition"));

var _FilterFieldPrice = _interopRequireDefault(require("../FilterFieldPrice"));

var _PriceRangeSliderField = _interopRequireDefault(require("../PriceRangeSliderField"));

// APP
//
var FieldComponent = function FieldComponent(props) {
  return /*#__PURE__*/_react.default.createElement(_FilterFieldPrice.default, (0, _extends2.default)({
    Component: _PriceRangeSliderField.default
  }, props));
};

function FilterConditionPrice(_ref) {
  var buildFilter = _ref.buildFilter,
      currency = _ref.currency,
      field = _ref.field,
      filter = _ref.filter,
      filterValue = _ref.filterValue,
      mode = _ref.mode,
      onChange = _ref.onChange,
      parentFilter = _ref.parentFilter,
      priceField = _ref.priceField,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "currency", "field", "filter", "filterValue", "mode", "onChange", "parentFilter", "priceField", "value"]);
  return /*#__PURE__*/_react.default.createElement(_FilterCondition.default, {
    mode: mode,
    FieldComponent: FieldComponent,
    FieldComponentProps: (0, _extends2.default)({
      buildFilter: buildFilter,
      currency: currency,
      field: field,
      filter: filter,
      filterValue: filterValue,
      onChange: onChange,
      priceField: priceField,
      parentFilter: parentFilter,
      value: value
    }, rest)
  });
}

process.env.NODE_ENV !== "production" ? FilterConditionPrice.propTypes = {
  buildFilter: _propTypes.default.func.isRequired,
  currency: _propTypes.default.string.isRequired,
  field: _propTypes.default.string.isRequired,
  filter: _propTypes.default.shape({}),
  filterValue: _propTypes.default.shape({}),
  mode: _propTypes.default.oneOf(['field', 'value']),
  onChange: _propTypes.default.func.isRequired,
  parentFilter: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))]),
  priceField: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)])
} : void 0;
FilterConditionPrice.defaultProps = {
  filter: undefined,
  filterValue: undefined,
  mode: undefined,
  parentFilter: undefined,
  priceField: 'salePriceWithTax',
  value: undefined
};
var _default = FilterConditionPrice;
exports.default = _default;